var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    { attrs: { type: "card" } },
    [
      _c("template", { slot: "header" }, [_vm._v("process.env")]),
      _c("d2-highlight", { attrs: { code: _vm.env } })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }